import React from 'react'
import { Disclaimer } from 'application/components/styledComponents/disclaimer'
import NonInsuranceDisclaimer from './nonInsuranceDisclaimer'
import InsuranceDisclaimer from './insuranceDisclaimer'
import { useLocation } from 'react-router-dom'

export const Govmarketingdisclaimer = () => {
  const location = useLocation()
  const proposalIndex = location.pathname.lastIndexOf('/')
  const result = location.pathname.substring(proposalIndex + 1)
  const insuranceDisclaimer =
    result === 'review' || result === 'pdfview' || result.indexOf('-') > -1
  return (
    <Disclaimer>
      {insuranceDisclaimer ? (
        <InsuranceDisclaimer />
      ) : (
        <NonInsuranceDisclaimer />
      )}
      <p>
        Salary packaging is only available to eligible employees of the
        Queensland Government as per the Standing Offer Arrangement QGP0065-21.
        The implications of salary packaging a motor vehicle through a novated
        leasing arrangement, including tax savings will depend on your
        individual circumstances. The information in this publication has been
        prepared by Remuneration Services Pty Ltd for general information
        purposes only, without taking into consideration any individual
        circumstances. Before acting on any information or entering into a
        novated leasing arrangement, you should consider your objectives,
        financial situation and needs, and, take the appropriate legal,
        financial or other professional advice based upon your own particular
        circumstances.{' '}
        <span>
          The Queensland Government strongly recommends that you obtain
          independent financial advice prior to entering into, or changing the
          terms of, a salary packaging arrangement.
        </span>
      </p>
      <p>
        *RemServ’s procurement, insurance and maintenance services are optional.
        You may choose to use our services or those of another provider.
      </p>
      <p>
        RemServ collects your personal information from you when you apply for a
        product and request any information from us, and we may use this
        information to contact you about our products, services and offerings.
        To read more about how we handle your personal information, please read
        our{' '}
        <a
          href="https://mmsg.com.au/privacy"
          className="text-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Statement
        </a>
        .
      </p>
      <p>
        The availability of benefits is subject to your employer's approval.
        RemServ may receive commissions in connection with its services.
      </p>
    </Disclaimer>
  )
}
